import { AUTH_USER_ACTIONS } from 'Actions/index';
import { AUTH_STATES, REQUEST_TYPES } from 'Utils/constants';
import client from 'graphQl/apollo';
import { GET_LOGGEDIN_USER_QUERY } from 'graphQl/queries/authUser';

const {
  SET_LOGGED_IN_USER_DETAILS,
  SET_AUTH_STATE,
  SET_REDIRECT_PATH,
  SET_ACCOUNT_SETTINGS,
} = AUTH_USER_ACTIONS;

const setLoggedInUserDetails = user => ({
  type: SET_LOGGED_IN_USER_DETAILS,
  payload: user,
});

const setAccountSettings = settings => ({
  type: SET_ACCOUNT_SETTINGS,
  payload: settings,
});

const setAuthState = authState => ({
  type: SET_AUTH_STATE,
  payload: { authState },
});

const setRedirectPath = redirectPath => ({
  type: SET_REDIRECT_PATH,
  payload: { redirectPath },
});

export const getLoggedInUserDetails = () => {
  return async dispatch => {
    try {
      let data = await client.query({
        query: GET_LOGGEDIN_USER_QUERY,
        variables: {},
      });
      dispatch(setLoggedInUserDetails(data.data.bootstrap));
      let accountServices = [];
      if (data.data.settings) {
        if (data.data.settings.enableMove) {
          accountServices.push(REQUEST_TYPES.MOVE);
        }
        if (data.data.settings.enableAirportTransfer) {
          accountServices.push(REQUEST_TYPES.AIRPORT_TRANSFER);
        }
        if (data.data.settings.enableShortStay) {
          accountServices.push(REQUEST_TYPES.SHORT_STAY);
        }
        if (data.data.settings.enableTicket) {
          accountServices.push(REQUEST_TYPES.TICKET);
        }
        if (data.data.settings.enableSettlingIn) {
          accountServices.push(REQUEST_TYPES.SETTLING_IN);
        }
        if (data.data.settings.enableHousing) {
          accountServices.push(REQUEST_TYPES.HOUSING);
        }
      }
      dispatch(
        setAccountSettings({
          accountServices,
          enableBudget: data.data.settings.enableBudget,
        })
      );
    } catch (err) {
      console.error('Error fetching logged in user details: ', err);
    }
  };
};

export const setUserSignedIn = () => dispatch =>
  dispatch(setAuthState(AUTH_STATES.SIGNED_IN));

export const setUserSignedOut = () => dispatch =>
  dispatch(setAuthState(AUTH_STATES.SIGNED_OUT));

export const setUserSigningIn = () => dispatch =>
  dispatch(setAuthState(AUTH_STATES.SIGNING_IN));

/**
 * Set the path to redirect to after the user signs in next time. Ignore parameter to redirect to the default page.
 * @param redirectPath
 */
export const setPostSigninRedirectPath = redirectPath => dispatch =>
  dispatch(setRedirectPath(redirectPath));
